import { render, staticRenderFns } from "./TransferGraduationSendDocument.vue?vue&type=template&id=edf8857a&scoped=true&"
import script from "./TransferGraduationSendDocument.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationSendDocument.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationSendDocument.vue?vue&type=style&index=0&id=edf8857a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf8857a",
  null
  
)

export default component.exports